// Module
var code = `<div class="heatmap-symbol-info">
    {{#if .heatmapData && .heatmapData.logoAddress}}
        <div class="heatmap-symbol-info-item heatmap-logo">
            <img src="{{ logoImage }}">
        </div>
    {{/if}}
    <div class="heatmap-symbol-info-item">
        <div class="heatmap-symbol-info-item-value heatmap-symbol-name">
            {{#if .heatmapData}}
                {{.heatmapData.symbol}}
            {{/if}}
        </div>
        <div class="heatmap-symbol-info-item-label">
            <div class="heatmap-symbol-description">
                {{#if .heatmapData}}
                    {{.heatmapData.symbolDescription}}
                {{/if}}
            </div>
        </div>
    </div>
    <div class="heatmap-symbol-info-item">
        <div class="heatmap-symbol-info-item-value">
            {{#if .heatmapData}}
                {{.heatmapData.lastPriceString}}
            {{/if}}
        </div>
        <div class="heatmap-symbol-info-item-label">
            {{.lastPriceLabel}}
        </div>
    </div>
    <div class="heatmap-symbol-info-item">
        <div class="heatmap-symbol-info-item-value">
            {{#if .heatmapData}}
                {{.heatmapData.changeString}}
            {{/if}}
        </div>
        <div class="heatmap-symbol-info-item-label">
            {{.changeLabel}}
        </div>
    </div>
    <div class="heatmap-symbol-info-item">
        <div class="heatmap-symbol-info-item-value">
            {{#if .heatmapData}}
                {{.heatmapData.changePercentString}}
            {{/if}}
        </div>
        <div class="heatmap-symbol-info-item-label">
            {{.changePercentLabel}}
        </div>
    </div>
    <div class="heatmap-symbol-info-item">
        <div class="heatmap-symbol-info-item-value">
            {{#if .heatmapData}}
                {{.heatmapData.marketCapString}}
            {{/if}}
        </div>
        <div class="heatmap-symbol-info-item-label">
            {{.marketCapLabel}}
        </div>
    </div>
</div>`;
// Exports
export default code;